module.exports = __webpack_public_path__ + "static/media/nuance-2-cropped.5a9c5b82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/nuance-2-cropped.jpg
// module id = 53
// module chunks = 0